import type { PaletteOptions } from "@mui/material/styles";

import { themeColors } from "./colors";
import { dark, light } from "./tokens";

/**
 * Augment the MUI palette with the app-specific tokens referenced from `sx`
 * (`theme.palette.surface.inset`, `theme.palette.text.muted`). Registering `link` and
 * the two ritual phases as palette colours makes MUI emit matching CSS variables
 * (`--mui-palette-link-main`) that switch with the scheme on their own.
 */
declare module "@mui/material/styles" {
  interface Palette {
    surface: { inset: string };
    /** Scrim + label for a chip that sits on artwork rather than on a page surface. */
    mediaScrim: { main: string; contrastText: string };
    link: { main: string };
    morning: { main: string };
    evening: { main: string };
  }
  interface PaletteOptions {
    surface?: { inset: string };
    mediaScrim?: { main: string; contrastText: string };
    link?: { main: string };
    morning?: { main: string };
    evening?: { main: string };
  }
  interface TypeText {
    muted: string;
  }
}

export const lightPalette: PaletteOptions = {
  mode: "light",
  primary: {
    main: themeColors.light.accent,
    dark: themeColors.light.accentPressed,
    contrastText: themeColors.light.onAccent,
  },
  background: { default: light.bg, paper: light.paper },
  surface: { inset: light.inset },
  mediaScrim: {
    main: themeColors.light.mediaScrim,
    contrastText: themeColors.light.onMediaScrim,
  },
  link: { main: themeColors.light.accentText },
  morning: { main: themeColors.light.morning },
  evening: { main: themeColors.light.evening },
  divider: light.divider,
  text: {
    primary: light.text,
    secondary: light.textSecondary,
    muted: light.textMuted,
  },
};

export const darkPalette: PaletteOptions = {
  mode: "dark",
  primary: {
    main: themeColors.dark.accent,
    dark: themeColors.dark.accentPressed,
    contrastText: themeColors.dark.onAccent,
  },
  background: { default: dark.bg, paper: dark.paper },
  surface: { inset: dark.inset },
  mediaScrim: {
    main: themeColors.dark.mediaScrim,
    contrastText: themeColors.dark.onMediaScrim,
  },
  link: { main: themeColors.dark.accentText },
  morning: { main: themeColors.dark.morning },
  evening: { main: themeColors.dark.evening },
  divider: dark.divider,
  text: {
    primary: dark.text,
    secondary: dark.textSecondary,
    muted: dark.textMuted,
  },
};
